<template>
    <div class="section-good">
        <div class="section-good__box">
            <div class="section-good__good">
                <div class="section-good__info">
                    <button @click="onBack" class="section-good__back-btn">
                        <icon-arrow-left class="section-good__back-btn-icon" />
                    </button>
                    <div class="section-good__title">{{ good.title }}</div>
                </div>
                <div class="section-good__content">
                    <block-good class="section-good__content-img" :id="good.id" />
                    <div class="section-good__description">{{ good.description }}</div>
                </div>
            </div>
            <div class="section-good__regions">
                <div class="section-good__title section-good__title-region">Выберите регион:</div>
                <div class="section-good__region" v-for="region in availableRegions" :key="region.id">
                    <button class="ui-btn accent streath section-good__region-btn" @click="onSelectRegion(region)">{{ region.title }}</button>
                </div>
            </div>

            <ui-popup ref="popup">
                <div class="section-good-confirm" v-if="region">
                    <div class="section-good-confirm__title">
                        Вы собираетесь продавать
                        <br><span class="section-good-confirm__title--accent">{{ good.title }}</span>
                        <template v-if="region.id === 6"> на </template>
                        <template v-else> в </template>
                        <span class="section-good-confirm__title--accent">{{ region.title2 }}</span>?
                    </div>
                    <div class="section-good-confirm__text">Стоимость: 1 балл</div>
                    <div class="section-good-confirm__actions">
                        <button class="section-good-confirm__actions-btn ui-btn" @click="onConfirm">Да!</button>
                        <button class="section-good-confirm__actions-btn section-good-confirm__actions-btn-cancel ui-btn" @click="onCancel">
                            Отменить
                        </button>
                    </div>
                </div>
            </ui-popup>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data () {
            return {
                region: null
            }
        },
        computed: {
            ...mapGetters('regions', ['availableRegions']),
            ...mapGetters('goods', ['goodInfoById']),
            good () {
                return this.goodInfoById(this.$route.params.id)
            }
        },
        methods: {
            ...mapActions('regions', ['createRegion']),

            onBack () {
                this.$router.push({name: 'game-goods'})
            },
            onCancel () {
                this.$refs.popup.close()
            },
            onConfirm () {
                this.createRegion({
                    regionId: this.region.id,
                    goodId: this.good.id
                })
                this.$refs.popup.close()
                this.$router.push({name: 'game-runtime'})
            },
            onSelectRegion (region) {
                this.region = region
                this.$refs.popup.open()
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-good {
        padding 0 6.3rem
        +layout-sm() {
            padding 0 2rem
        }

        &__box {
            border-top 0.2rem solid #3665F3
            padding 3.6rem 0 3rem 0
            display grid
            grid-template-columns minmax(31rem, 1fr) 33.3rem
            +layout-sm() {
                border-top 0 none
                padding 3rem 0 0 0
                grid-template-columns 1fr
                grid-auto-flow column
                grid-template-rows auto auto
            }
        }

        &__good {
            +layout-sm() {
                /*padding: 2rem*/
                padding-bottom 2rem
            }
            +layout-xs() {
                padding-bottom 3.2rem
            }

        }

        &__info {
            margin-top -0.5rem
            margin-bottom 0.5rem
            display flex
            align-items center
        }

        &__back-btn {
            width 3.8rem
            height @width
            border-radius 50%
            display inline-flex
            justify-content center
            align-items center
            padding 0
            flex-shrink 0
            border 0
            color $color-accent
            background-color #3665F3
            cursor pointer
            transition background-color 0.3s ease, color 0.3s ease
            outline none
            user-select none
            margin-right 1.4rem
            +layout-sm() {
                position relative
                top -0.3rem
            }
            +layout-xs() {
                top -0.1rem
                width 2.9rem
                height 2.9rem
            }

            &:hover {
                background-color #2B0EAF
                color #382AEF
            }

            &:active {
                opacity 0.9
            }

            &-icon {
                width 1.2rem
                height 2rem
                position relative
                display flex
                right 0.1rem
                +layout-xs() {
                    top -0.1rem
                    width 0.9rem
                    height 1.6rem
                }
            }
        }

        &__title {
            font-size 2rem
            line-height 2.4rem
            font-weight $font-bold

            &-region {
                margin-bottom 1.4rem
                +layout-sm() {
                    color #2B0EAF
                }
            }
        }

        &__content {
            max-width 34rem
            box-sizing border-box
            margin-left 5.4rem
            padding-right 2rem
            @media (max-width: 840px) {
                margin-left 0
                margin-top 2rem
            }
            +layout-sm() {
                display flex
                flex-direction column
                align-items center
                width 100%
                max-width 100%
                padding-right 0

            }
            +layout-xs() {
                margin-top 1.6rem
            }

            &-img {
                pointer-events none
                padding-bottom 63%
                +layout-xs() {
                    padding-bottom 57%
                }
            }
        }

        &__description {
            font-size 1.5rem
            line-height 1.8rem
            margin-top 1.5rem
        }

        &__regions {
            border-left 0.1rem solid #3665F3
            padding-left 4rem

            @media (max-width: 840px) {
                padding-left 2rem
            }
            +layout-sm() {
                margin-left: -2rem
                margin-right: -2rem
                padding 2rem
                background-color $color-accent
            }
        }

        &__region {
            & + & {
                margin-top 0.6rem
                +layout-xs() {
                    margin-top 0.5rem
                }
            }

            &-btn {
                +layout-sm() {
                    background-color #3615F3
                    color $color-accent
                }
            }
        }
    }

    .section-good-confirm {
        width 35rem

        +layout-xs() {
            width 30rem
        }
        +layout-xxs() {
            width 23.6rem
        }

        &__title {
            font-size 2rem
            line-height 2.8rem

            &--accent {
                font-weight $font-bold
            }
        }

        &__text {
            margin-top 1.1rem
            font-size 1.5rem
            line-height 2.8rem
        }

        &__actions {
            margin-top 1.9rem
            display flex

            +layout-xs() {
                display block
            }

            &-btn {
                background-color #121258
                color $color-accent
                flex-basis 50%

                & + & {
                    margin-left 1rem
                }

                +layout-xs() {
                    width 100%

                    & + & {
                        margin-left 0
                        margin-top 1rem
                    }
                }

                &-cancel {
                    background-color #3665F3
                }

                &:hover {
                    background-color $color-accent
                    color #121258
                }
            }

            &-btn-confirm {

            }
        }

    }
</style>
